import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

export const FREE_LIMIT = 3;

export function useGenerationCount() {
  const { user } = useAuth();
  const [usedCount, setUsedCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchCount = useCallback(async () => {
    if (!user) {
      setUsedCount(0);
      setLoading(false);
      return;
    }
    const { count } = await supabase
      .from('ad_generations')
      .select('*', { count: 'exact', head: true })
      .eq('user_id', user.id);

    setUsedCount(count ?? 0);
    setLoading(false);
  }, [user]);

  useEffect(() => {
    fetchCount();
  }, [fetchCount]);

  const remaining = Math.max(0, FREE_LIMIT - usedCount);
  const isExhausted = usedCount >= FREE_LIMIT;

  return {
    usedCount,
    remaining,
    isExhausted,
    loading,
    refetch: fetchCount,
    FREE_LIMIT,
  };
}